import { createAskQuestion } from './create-ask-question';
import { createMakeComment } from './create-make-comment';
import { doAll } from './do-all';
import { doNothing } from './do-nothing';
import { setNext } from './set-next';
import { useAnswer } from './use-answer';
import { withValidation } from './with-validation';

export const createCommonTools = <TId extends string>() => ({
  askQuestion: createAskQuestion<TId>(),
  makeComment: createMakeComment<TId>(),
  doAll,
  doNothing,
  setNext,
  useAnswer,
  withValidation,
});
